import type { FC } from "react";

import type { RepositoryIndexingRun } from "../../types";

import { formatTimestamp } from "../../utils/sourceControlIndexing";
import { ListItemCard, ListItemCardHeader } from "../common/ListItemCard";
import { StatsGrid } from "../common/StatsGrid";
import { StatusBadge } from "../common/StatusBadge";

interface IndexingRunCardProps {
  run: RepositoryIndexingRun;
  selected: boolean;
  onSelect: (runId: string) => void;
}

export const IndexingRunCard: FC<IndexingRunCardProps> = ({
  run,
  selected,
  onSelect,
}) => (
  <li>
    <ListItemCard
      clickable
      selected={selected}
      padding="md"
      onClick={() => onSelect(run.run_id)}
      className="rounded-none hover:bg-emerald-50/50 dark:hover:bg-emerald-500/10"
      header={
        <ListItemCardHeader
          title={run.run_type}
          subtitle={`Started ${formatTimestamp(run.started_at)}`}
        />
      }
      actions={<StatusBadge status={run.status} />}
    >
      <StatsGrid
        className="mt-3 text-gray-600 dark:text-white/70"
        items={[
          {
            label: "Repositories",
            value:
              run.repository_count ??
              (run.metadata as { repositoryCount?: number } | null)
                ?.repositoryCount ??
              run.item_counts.total,
          },
          { label: "Insights", value: run.insight_count },
          {
            label: "Completed",
            value: `${run.item_counts.succeeded}/${run.item_counts.total}`,
          },
          { label: "Requested By", value: run.requested_by ?? "system" },
        ]}
      />
    </ListItemCard>
  </li>
);
